import { mainUrl } from "./apiSettings";

// GET - https://w8d8xqggdi.execute-api.sa-east-1.amazonaws.com/dev/user/{email}/points
export const GET_POINTS_BY_EMAIL = (email) => `${mainUrl}/user/${email}/points`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/profile/{userId}
export const GET_DISPLAY_BY_EMAIL = (userId) => `${mainUrl}/profile/${userId}`;

// PATCH - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/profile
export const PATCH_USER_INFORMATION = `${mainUrl}/profile`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/profile/avatar/{userId}
export const GET_USER_AVATAR = (userId) => `${mainUrl}/profile/avatar/${userId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/ranking
export const GET_RANKING = `${mainUrl}/ranking`

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/performance/{userId}
export const GET_USER_PERFORMANCE = (userId) => `${mainUrl}/performance/${userId}`;

// GET - https://2hd3lo5b77.execute-api.sa-east-1.amazonaws.com/dev/performance/{userId}/{journeyId}
export const GET_USER_JOURNEYS_LOG = (userId, journeyId) => `${mainUrl}/performance/${userId}/${journeyId}`;


